import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import WidgetContainer from 'components/widget/WidgetContainer';
import PackPayments from 'components/PackPayments';
import { FullWidthPaperContent } from './Paper';
import WidgetHeading from './widget/WidgetHeading';

const Wrapper = styled(WidgetContainer)``;

const NoNextPackWidget = ({ className, previousPack }) => {
  const classes = ['NoNextPackWidget'];
  if (className) classes.push(className);

  return (
    <Wrapper className={classes.join(' ')}>
      <FullWidthPaperContent className="section">
        <WidgetHeading>Upcoming delivery</WidgetHeading>
        <p>
          There are no further deliveries scheduled for this subscription.
          Please contact your store to ensure your supply is not interrupted.
        </p>
      </FullWidthPaperContent>
      <FullWidthPaperContent className="section">
        <h4>Payments for your previous delivery</h4>
        <PackPayments payments={previousPack.payments} packStatus={previousPack.status} />
      </FullWidthPaperContent>
    </Wrapper>
  );
};

NoNextPackWidget.displayName = 'NoNextPackWidget';

NoNextPackWidget.propTypes = {
  className: PropTypes.string,
  previousPack: PropTypes.arrayOf(PropTypes.shape({
    payments: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    status: PropTypes.string.isRequired,
  })).isRequired,
};

NoNextPackWidget.defaultProps = {
  className: null,
};

export default NoNextPackWidget;
